var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { GoButton } from "core/components/GoButton";
import { ArrowCta } from "hero/components/ArrowCta";
import { Id, config, content, gtm } from "core/utils";
import CountdownCta from "hero/components/CountdownCta";
export var Cta = function (_a) {
    var variant = _a.variant, onCountdownEnd = _a.onCountdownEnd, channel = _a.channel, trackingObject = _a.trackingObject, className = _a.className;
    switch (variant.kind) {
        case "Blank":
            return null;
        case "VtmGoLive":
            return (React.createElement(GoButton, { isColourLogo: true, url: config.urls.vtmgoLive(channel), "data-component": Id.component.vtmgoButton.live, "data-gtm": gtm.attribute.hero.liveButton, trackingObject: trackingObject, className: className }, content.vtmgoLive));
        case "VtmGoOnDemand":
            return (React.createElement(GoButton, { isColourLogo: true, url: variant.url, "data-component": Id.component.vtmgoButton.onDemand, "data-gtm": gtm.attribute.hero.demandButton, trackingObject: trackingObject, className: className }, content.vtmgoOnDemand));
        case "VtmGoPlus":
            return (React.createElement(GoButton, { isColourLogo: true, plus: true, url: variant.url, "data-component": Id.component.vtmgoButton.onDemand, "data-gtm": gtm.attribute.hero.demandButton, trackingObject: trackingObject, className: className }, content.vtmgoPlusOnDemand));
        case "Arrow":
            return React.createElement(ArrowCta, { data: variant.cta, className: className });
        case "Countdown":
            return (React.createElement(CountdownCta, { countdown: __assign(__assign({}, variant.countdown), { duration: variant.duration }), cta: variant.cta, onCountdownEnd: onCountdownEnd, className: className }));
    }
};
